<template>
  <div>
    <p class="payers">{{ StringLanguage.payers }}</p>

    <div v-for="(oPayer, iPayer) in payers" :key="iPayer" class="payer-box">
      <div>
        <p class="mb_5" v-if="oPayer.user && oPayer.user.name">
          Pagante {{ iPayer + 1 }}
        </p>
        <p>
          {{ `${Method[oPayer.method].name} (${getPaymentMethod(oPayer)})`
          }}{{
            oPayer.changeFor > 0
              ? ` - ${StringLanguage.chargeFor}: ${Utils.convertMoney(
                  oPayer.changeFor
                )} (${Utils.convertMoney(oPayer.changeFor - oPayer.amount)})`
              : ''
          }}
        </p>
      </div>
      <p>{{ Utils.convertMoney(oPayer.amount) }}</p>
    </div>
  </div>
</template>

<script>
import { Method, PaymentMethod } from 'easyjs/lib/Schema/Payment';
import Utils from '@/utils';

export default {
  props: {
    payers: [],
  },
  data() {
    return {
      Method,
      Utils,
    };
  },
  methods: {
    getPaymentMethod(oPayer) {
      const pM = oPayer.paymentMethod;
      let pMString = '';

      if ((pM & PaymentMethod.CREDIT) === PaymentMethod.CREDIT) {
        pMString = StringLanguage.credit;
      } else if ((pM & PaymentMethod.DEBIT) === PaymentMethod.DEBIT) {
        pMString = StringLanguage.debit;
      } else if ((pM & PaymentMethod.VOUCHER) === PaymentMethod.VOUCHER) {
        pMString = StringLanguage.voucher;
      } else if ((pM & PaymentMethod.MONEY) === PaymentMethod.MONEY) {
        pMString = StringLanguage.money;
      }

      if ((pM & PaymentMethod.ONLINE) === PaymentMethod.ONLINE) {
        pMString += ' ';
        pMString += StringLanguage.online;
      }

      return pMString;
    },
  },
};
</script>

<style scoped>
.payers {
  font-size: 1.4em;
  margin-bottom: 25px;
  color: #aaaaaaed;
}
.payer-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.payer-box:not(:last-child) {
  margin-bottom: 15px;
}

.payer-box p {
  font-size: 1.2em;
}

.payer-box p:first-child {
  font-weight: bold;
}
</style>
